module.exports = __webpack_public_path__ + "static/media/dest5.c03fe16e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/tepual/destinations/dest5.jpg
// module id = 1671
// module chunks = 0